import { Injectable } from '@angular/core';
import { CheckInFormData } from '../../models/utils/check-in.interfaces';

@Injectable({
  providedIn: 'root'
})
export class CheckInNavigationService {
  private readonly FORM_TO_SESSION_MAPPING = {
    searchType: 'checkinSearchType',
    eticketNumber: 'checkinETicketNumber',
    skymilesNumber: 'checkinSkymilesNumber',
    creditcardNumber: 'checkinCreditcardNumber',
    lastName: 'checkinLastName',
    confirmationNumber: 'checkinConfirmationNumber',
    departureAirport: 'checkinDepartureAirport',
    startFrom: 'checkinStartFrom'
  } as const;

  navigateToCheckInFindPNR(
    checkinWidgetForm: CheckInFormData,
    submitNewUrl: string,
    openNewTab?: boolean
  ): void {
    this.clearCheckInSessionData();
    this.saveFormDataToSession(checkinWidgetForm);
    this.setDeepLinkFlow();
    this.navigateToUrl(submitNewUrl, openNewTab);
  }

  private clearCheckInSessionData(): void {
    Object.values(this.FORM_TO_SESSION_MAPPING).forEach((sessionKey) => {
      sessionStorage.removeItem(sessionKey);
    });
  }

  private saveFormDataToSession(formData: CheckInFormData): void {
    Object.entries(this.FORM_TO_SESSION_MAPPING).forEach(
      ([formKey, sessionKey]) => {
        const value = formData[formKey as keyof CheckInFormData];
        if (value) {
          sessionStorage.setItem(sessionKey, String(value));
        }
      }
    );
  }

  private setDeepLinkFlow(): void {
    sessionStorage.setItem('deepLinkFlow', 'true');
  }

  private navigateToUrl(url: string, openNewTab?: boolean): void {
    if (openNewTab) {
      window.open(url, '_blank');
    } else {
      window.location.href = url;
    }
  }
}
